import { theme } from '@garnish/constants';

import { type CloudinaryTransformConfig, type ContentfulImageTransformOptions } from '../Image';

export const IMAGE_SIZE = 343;

export const IMAGE_TRANSFORM_CONFIG: CloudinaryTransformConfig = [
  { crop: 'crop', height: 0.7, width: 0.4 },
  { width: IMAGE_SIZE },
];

export const IMAGE_TRANSFORM_CONFIG_CONTENTFUL: Partial<ContentfulImageTransformOptions> = {
  fm: 'webp',
  q: 70,
  w: IMAGE_SIZE,
  fit: 'scale',
};

export const CONTAINER_PADDING_X_MEDIUM = theme.spacing['4'];
export const CONTAINER_PADDING_LARGE = theme.spacing['6'];
